const formatInvoiceCropName = cropSeasons => {
  const cropNames = cropSeasons?.map(season => season.name) || [];
  const formattedCropNames =
    cropNames.length === 0 ? 'N/A' : cropNames.join(', ');
  return formattedCropNames;
};

export default formatInvoiceCropName;
